import { TOrganizi8AppState } from '../organizi8.reducer';
import { StorageDBActions, TStorageDBActionTypes } from './storage.actions';

const initialState: TOrganizi8AppState['storage'] = {
  GRNDetails: {
    FABRIC: {},
    TRIMS: {},
  },
  RollsAndItemsDetails: {
    FABRIC: {},
    TRIMS: {},
  },
};

export const StorageStateReducer = (
  state = initialState,
  action: TStorageDBActionTypes,
): TOrganizi8AppState['storage'] => {
  switch (action.type) {
    case StorageDBActions.ClearAndFetchFabricStorageGRNDetails:
      return {
        ...state,
        GRNDetails: {
          ...state.GRNDetails,
          FABRIC: {},
        },
      };
    case StorageDBActions.ClearAndFetchFabricStorageGRNDetailsSuccess:
      return {
        ...state,
        GRNDetails: {
          ...state.GRNDetails,
          FABRIC: {
            res: action.res,
          },
        },
      };
    case StorageDBActions.ClearAndFetchTrimsStorageGRNDetails:
      return {
        ...state,
        GRNDetails: {
          ...state.GRNDetails,
          TRIMS: {},
        },
      };
    case StorageDBActions.ClearAndFetchTrimsStorageGRNDetailsSuccess:
      return {
        ...state,
        GRNDetails: {
          ...state.GRNDetails,
          TRIMS: {
            res: action.res,
          },
        },
      };
    case StorageDBActions.ClearAndFetchFabricStorageRollsDetails:
      return {
        ...state,
        RollsAndItemsDetails: {
          ...state.RollsAndItemsDetails,
          FABRIC: {},
        },
      };
    case StorageDBActions.ClearAndFetchFabricStorageRollsDetailsSuccess:
      return {
        ...state,
        RollsAndItemsDetails: {
          ...state.RollsAndItemsDetails,
          FABRIC: {
            res: action.res,
          },
        },
      };
    case StorageDBActions.ClearAndFetchTrimsStorageItemDetails:
      return {
        ...state,
        RollsAndItemsDetails: {
          ...state.RollsAndItemsDetails,
          TRIMS: {},
        },
      };
    case StorageDBActions.ClearAndFetchTrimsStorageItemDetailsSuccess:
      return {
        ...state,
        RollsAndItemsDetails: {
          ...state.RollsAndItemsDetails,
          TRIMS: {
            res: action.res,
          },
        },
      };
  }
  return state;
};
